import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ExamsRepositoriesProvider } from '_/features/exams/ui/contexts/exams-repositories-provider'

const ExamsLayout = () => {
	return (
		<ExamsRepositoriesProvider>
			<Outlet />
		</ExamsRepositoriesProvider>
	)
}

export const Route = createFileRoute('/_authenticated/exams')({
	component: ExamsLayout,
})
